// extracted by mini-css-extract-plugin
export default {"row-with-actions":"styles_row-with-actions__BOMnU","price":"styles_price__DydZe","action":"styles_action__fjPpu","row":"styles_row__sUAsw"};